<!-- 回放 -->
<template>
  <div @click.stop>
    <div class="modal-content" @click="NoshowCalendar">
      <div class="siteName">工地名称：{{ record.ws_name }}</div>
      <div class="deviseList">
        <div v-for="(item, index) in ws_bind_d_ids" :key="index">
          <div @click="changed_id(item, index)" class="deviseList_name">
            设备{{ index + 1 }}
          </div>
          <!-- <div @click="changed_id(item, index)" class="deviseList_name">
            设备{{ item }}
          </div> -->
        </div>
      </div>
      <span>日期：</span>
      <a-input
        v-model="dataTime"
        placeholder="请选择日期"
        @focus="showCalendar"
        class="calendar_input"
      />
      <a-calendar
        v-model="dataTime"
        :fullscreen="false"
        :disabled-date="disabledDate"
        @change="onChangeDate"
        class="model-site-input calendar_rili"
        v-show="isshowCalendar"
      >
        <template slot="dateCellRender" slot-scope="value">
          <!-- <span v-if="showSpot(value)">
            <a-badge status="error" />
          </span> -->
          <span v-if="showSpot_lv(value)">
            <a-badge status="success" />
          </span>
        </template>
      </a-calendar>
      <!-- </a-date-picker> -->

      <!-- <br /> -->
      <!-- <a-icon
        type="environment"
        theme="twoTone"
        class="model-site-name"
        style="margin-top: 16px"
      />

      <span>{{ record.ws_name }}</span> -->
    </div>
    <div class="modal-content">
      <div v-if="list.length > 0" class="haveVideo">
        <div class="haveVideo_left">
          <div style="height: 20px; width: 100%; color: #1890ff">
            {{ showName ? (showVideo ? nowplayname : "正在请求视频") : "" }}
          </div>
          <video
            v-if="showVideo"
            controls
            width="100%"
            height="300px"
            id="video"
            autoplay
            preload="auto"
            :src="video.play"
            controlslist="nodownload"
          >
            <source :src="video.play" type="video/mp4" />
          </video>

          <video v-if="!showVideo" controls width="100%" height="300px" />

          <!-- 按钮 -->
          <div v-show="showVideo" class="speed-btn">
            <!-- 暂停静音全屏按钮 -->
            <div class="playBTN">
              <div
                class="v-btn"
                v-show="bofang == 1 ? true : false"
                @click="bofangPlay('bofang')"
              >
                <a-icon type="caret-right" />
              </div>
              <div
                class="v-btn"
                v-show="bofang == 2 ? true : false"
                @click="bofangPlay('zanting')"
              >
                <a-icon type="pause" />
              </div>

              <!-- 静音/取消静音按钮 -->
              <div
                class="v-btn"
                v-show="jingyin == 1 ? true : false"
                @click="handelPlay('jingyin')"
              >
                <!-- 静音 -->
                <img
                  src="../../assets/images/site_img/quxiaojingyin.png"
                  height="16px"
                />
              </div>
              <div
                class="v-btn"
                v-show="jingyin == 2 ? true : false"
                @click="handelPlay('quxiaojingyin')"
              >
                <!-- 取消静音 -->

                <img
                  src="../../assets/images/site_img/jingyin.png"
                  height="20px"
                />
              </div>

              <!-- <a-button type="primary" ghost @click="bofangRate()">
              <a-icon type="forward" />播放速度
            </a-button> -->
              <!-- 全屏按钮 -->
              <div class="v-btn quanping" @click="quanping()">
                <a-icon type="fullscreen" />
              </div>
            </div>
            <!-- 前进后退10秒 -->
            <div class="speedBTN">
              <a-tooltip style="outline: none">
                <template slot="title"> 后退10秒 </template>
                <svg
                  @click="speed('back')"
                  @mouseover="aftermouseOver"
                  @mouseleave="aftermouseLeave"
                  t="1644822468201"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1267"
                  width="45"
                  height="45"
                >
                  <path
                    d="M656.9 680.5l-250-144.3c-17.7-10.2-17.7-35.7 0-45.9L656.8 346c17.7-10.2 39.8 2.6 39.8 23v288.6c0 20.3-22.1 33.1-39.7 22.9z"
                    :fill="afterplayBackground2"
                    p-id="1268"
                  ></path>
                  <path
                    d="M531.3 680.5L281.4 536.2c-17.7-10.2-17.7-35.7 0-45.9L531.3 346c17.7-10.2 39.8 2.6 39.8 23v288.6c0 20.3-22.1 33.1-39.8 22.9z"
                    :fill="afterplayBackground1"
                    p-id="1269"
                  ></path>
                  <path
                    d="M514 912c-219.9 0-398.8-178.9-398.8-398.8S294.1 114.3 514 114.3s398.9 178.9 398.9 398.9C912.8 733.1 733.9 912 514 912z m0-701.5c-166.9 0-302.7 135.8-302.7 302.7S347.1 815.9 514 815.9s302.7-135.8 302.7-302.7S680.9 210.5 514 210.5z"
                    :fill="afterplayBackground2"
                    p-id="1270"
                  ></path>
                </svg>
              </a-tooltip>
              <a-tooltip style="outline: none">
                <template slot="title"> 前进10秒 </template>
                <svg
                  @click="speed('forward')"
                  @mouseover="frontmouseOver"
                  @mouseleave="frontmouseLeave"
                  t="1644821480551"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2474"
                  width="45"
                  height="45"
                >
                  <path
                    d="M371.1 345.9L621 490.2c17.7 10.2 17.7 35.7 0 45.9L371.1 680.5c-17.7 10.2-39.8-2.6-39.8-23V368.9c0-20.4 22.2-33.2 39.8-23z"
                    :fill="frontplayBackground2"
                    p-id="2475"
                  ></path>
                  <path
                    d="M496.7 345.9l249.9 144.3c17.7 10.2 17.7 35.7 0 45.9L496.7 680.5c-17.7 10.2-39.8-2.6-39.8-23V368.9c0-20.4 22.1-33.2 39.8-23z"
                    :fill="frontplayBackground1"
                    p-id="2476"
                  ></path>
                  <path
                    d="M514 912c-219.9 0-398.8-178.9-398.8-398.9 0-219.9 178.9-398.8 398.8-398.8s398.9 178.9 398.9 398.8c-0.1 220-179 398.9-398.9 398.9z m0-701.5c-166.9 0-302.7 135.8-302.7 302.7S347.1 815.9 514 815.9s302.7-135.8 302.7-302.7S680.9 210.5 514 210.5z"
                    :fill="frontplayBackground2"
                    p-id="2477"
                  ></path>
                </svg>
              </a-tooltip>
            </div>
            <div class="playBTN">
              <div class="v-btn downPlay" @click="downPlay()">
                <a-tooltip>
                  <template slot="title"> 下载 </template> 下载</a-tooltip
                >
              </div>
              *下载当前视频
            </div>
            <!-- <a-button @click="downPlay()" style="margin-left: 10px;">下载</a-button> -->
          </div>
        </div>
        <div class="haveVideo_right">
          <div class="videoListLength">共{{ videoList.length }}个视频</div>
          <div class="border">
            <div
              v-for="(item, index) in videoList"
              :key="item.p_id"
              class="pointer"
            >
              <div @click="playVideo(item, index)" class="p_name_date">
                <p>
                  {{
                    $Format(item.p_name[0], "date") +
                    " " +
                    $Format(item.p_name[0], "times")
                  }}
                </p>
                <p class="p_name_time">
                  &nbsp;
                  {{ Math.trunc((item.p_name[1] - item.p_name[0]) / 60) }}分钟{{
                    Math.trunc(
                      (((item.p_name[1] - item.p_name[0]) / 60).toFixed(2) %
                        1) *
                        60
                    )
                  }}秒
                </p>

                <p>{{ item.p_isfile == "1" ? "@" : "" }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="list.length == 0" class="NoVideo">暂无视频播放</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { GetEvent, PlaybackStart, PlaybackIndex, Playback } from "@/api/video";
import { urlConfig } from "@/config/config";
export default {
  name: "SitePlayback",
  props: {
    record: {
      type: Object,
      default: {
        w_id: "",
        ws_id: "",
        ws_name: "",
      },
    },
  },
  data() {
    return {
      dateList: [],
      dateList1: [],
      dataTime: "",
      events: [
        { e_id: "all", e_name: "全部" },
        { e_id: "bad", e_name: "不整洁" },
        { e_id: "cameraproblem", e_name: "摄像头歪曲" },
        { e_id: "noclothes", e_name: "未穿工服" },
        { e_id: "smoking", e_name: "有人吸烟" },
      ],
      queryParam: {
        nowork: "all",
        ws_id: "", // 工地视频回放id
        ws_time: "", // 查看时间戳
        ws_time1: new Date(new Date().setHours(0, 0, 0, 0)) / 1000, // 查看时间戳
        w_id: "", // 工地id
        type: "",
      },
      showVideo: false,
      showName: false,
      isshowCalendar: false,
      video: {
        play: "",
      },
      date: "", //默认时间
      time1: "",
      time2: "",
      dateFormat: "YYYY-MM-DD",
      morenDate: "",
      i: -1,
      j: -1,
      list: [],
      shijianchuo: new Date(new Date().setHours(0, 0, 0, 0)) / 1000,
      videoList: [],
      cycleMax: 60,
      cycleTime: 1,
      timer: null, // 定时器
      // 推流
      streamer: {},
      //当前视频文件的名字
      nowplayname: "",
      //快退
      afterplayBackground1: "#333333",
      afterplayBackground2: "#d9d9d9",
      //快进
      frontplayBackground1: "#333333",
      frontplayBackground2: "#d9d9d9",
      //下载
      downplayBackground1: "#333333",
      downplayBackground2: "#d9d9d9",
      jingyin: 1,
      bofang: 2,
      ws_timeIndex: new Date(new Date().setHours(0, 0, 0, 0)) / 1000,
      startValue: null,
      endValue: null,
      endOpen: false,
      ws_bind_d_ids: [],
      d_id: "",
    };
  },
  created() {},
  mounted() {
    console.log("this.record", this.record);
    this.queryParam.ws_id = this.record.ws_id;
    this.ws_bind_d_ids = this.record.ws_bind_d_ids.split(",");
    this.ws_bind_d_ids = this.ws_bind_d_ids.slice(
      0,
      this.ws_bind_d_ids.length - 1
    );
    this.queryParam.d_id = this.ws_bind_d_ids[0];
    this.startMoren();
    this.getdateList();
    // 默认播放最近一天有回放视频的回放视频

    // this.onChangeDate();

    // console.log(this.$moment().subtract(30, "days").format("YYYY-MM-DD"));
    document.addEventListener("click", this.bodyCloseMenus);
    this.startValue = moment(Date.parse(new Date()) - 1000 * 60 * 60 * 24 * 7);
    this.endValue = moment(new Date());
    // 默认播放的第一个设备为蓝色字体
    setTimeout(() => {
      let BGCblue = document.getElementsByClassName("deviseList_name");
      // BGCblue[0].style.color = "#1890ff";
      //被点击
      BGCblue[0].style.color = "#cfe7fa";
      BGCblue[0].style.background = "#1486e6";
    }, 1000);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.bodyCloseMenus);
  },
  watch: {
    startValue(val) {},
    endValue(val) {},
  },
  methods: {
    moment,
    showSpot(value) {
      let flag;
      this.dateList.map((date) => {
        if (date == value.format("YYYY-MM-DD")) {
          flag = true;
        }
      });
      return flag;
    },
    // 绿点   有回放视频
    showSpot_lv(value) {
      let flag;
      this.dateList1.map((date) => {
        if (date == value.format("YYYY-MM-DD")) {
          flag = true;
        }
      });
      return flag;
    },
    // 点击空白处关闭日历组件弹窗
    bodyCloseMenus(e) {
      let self = this;
      if (self.isshowCalendar == true) {
        self.isshowCalendar = false;
      }
    },
    // 选择日期只能选之前的时间
    disabledDate(current) {
      return current && current >= this.$moment().endOf("day");
      // return (
      //   current < this.$moment().subtract(7, "days") ||
      //   current >= this.$moment().endOf("day")
      // );
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },

    onChangeDate(date, dateString) {
      const d = new Date(this.dataTime._d);
      const resDate =
        d.getFullYear() +
        "-" +
        this.p(d.getMonth() + 1) +
        "-" +
        this.p(d.getDate());

      this.dataTime = resDate;
      let resDate1 = new Date(resDate).getTime() / 1000;
      // console.log(resDate1);

      let today = new Date().getTime();
      this.queryParam.ws_time = this.dataTime
        ? parseInt(new Date(this.dataTime).getTime() / 1000)
        : parseInt(resDate1);
      // this.queryParam.ws_time = resDate1;
      // console.log(this.queryParam.ws_time);
      this.start();
      this.isshowCalendar = false;
    },
    // 获取需要加红点或蓝点
    getdateList() {
      let params = {
        ws_id: this.queryParam.ws_id,
        d_id: this.queryParam.d_id,
        ws_time: this.queryParam.ws_time1,
      };
      PlaybackStart(params).then((res) => {
        setTimeout(() => {
          // console.log(this.queryParam.ws_time1);
          PlaybackIndex(params).then((res) => {
            // console.log(res);
            // let i = 0;
            if (this.j < 8) {
              // console.log("77", this.j);
              this.j = this.j + 1;
              var timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
              // 一天是86400秒   故 7 天前的时间戳为
              var SevenDayAgo = timeStamp - 86400 * this.j;
              this.queryParam.ws_time1 = SevenDayAgo;
              // this.j = this.j + 1;
              // this.shijianchuo = SevenDayAgo;
              if (res.code == "400") {
                // console.log(res);
                let aaa = this.timestampToTime(res.msg * 1000, 0);
                this.dateList.push(aaa.replace(" ", ""));
              } else {
                let bbb = this.timestampToTime(res.msg * 1000, 0);
                this.dateList1.push(bbb.replace(" ", ""));
              }
              this.getdateList();
            }
          });
        }, 100);
      });
    },
    showCalendar() {
      this.isshowCalendar = true;
    },
    NoshowCalendar() {
      // this.isshowCalendar = false;
    },
    fetchEvent() {
      let params = {
        ws_id: this.queryParam.ws_id,
      };
      GetEvent(params).then((res) => {});
    },
    // 获取前i天的日期
    timestampToTime(timestamp, i) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        date.getDate() < 10 ? "0" + date.getDate() : date.getDate() - i + "";
      return Y + M + D;
    },
    //  将日期转化为时间戳格式 获取前一天的时间戳--time1
    getshijianchuo(time, i) {
      var time = new Date(this.timestampToTime(Date.parse(new Date()), i));
      var time1 = time.getTime();
      return time1;
    },
    // 七天内最近一天有回放视频的日期
    getHuifangVideo() {
      let params = {
        ws_id: this.queryParam.ws_id,
        // ws_time: this.shijianchuo,
        d_id: this.queryParam.d_id,
        ws_time: this.ws_timeIndex,
      };
      PlaybackIndex(params).then((res) => {
        if (res.code == "200") {
          console.log("aaa" + res.code);
          this.list = [];
          res.data.forEach((el) => {
            this.list.push({
              p_id: el.p_id,
              p_name: el.p_name.split("_"),
              status: "0",
            });
          });
          this.videoList = this.list;
          this.dataTime = this.timestampToTime(res.msg * 1000, 0);
          this.playVideo(this.videoList[0], 0);
        } else {
          if (this.i < 7) {
            this.i = this.i + 1;
            var timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
            // // 一天是86400秒   故 7 天前的时间戳为
            var SevenDayAgo = timeStamp - 86400 * this.i;
            this.queryParam.ws_time = SevenDayAgo;
            let shijianchuo = SevenDayAgo;
            this.ws_timeIndex = shijianchuo;
            // this.getHuifangVideo();
            this.startMoren();
          } else {
            this.list = [];
          }
        }
      });
    },
    getDateTime(time) {
      console.log(this.morenDate);
      return this.morenDate
        ? moment(this.morenDate, "YYYY-MM-DD")
        : "2022-12-18";
    },
    startMoren() {
      let params = {
        ws_id: this.queryParam.ws_id,
        // ws_time: this.queryParam.ws_time,
        d_id: this.queryParam.d_id,
        ws_time: this.shijianchuo,
      };
      PlaybackStart(params).then((res) => {
        setTimeout(() => {
          // this.fetchIndex();
          this.getHuifangVideo();
        }, 1000);
      });
    },

    start() {
      let params = {
        ws_id: this.queryParam.ws_id,
        d_id: this.queryParam.d_id,
        ws_time: this.queryParam.ws_time,
      };
      PlaybackStart(params).then((res) => {
        setTimeout(() => {
          this.fetchIndex();
        }, 1000);
      });
    },
    fetchIndex() {
      let params = {
        ws_id: this.queryParam.ws_id,
        d_id: this.queryParam.d_id,
        ws_time: this.queryParam.ws_time,
      };
      PlaybackIndex(params).then((res) => {
        this.list = [];
        // console.log(res.code);
        if (res.code == "200") {
          res.data.forEach((el) => {
            this.list.push({
              p_id: el.p_id,
              p_name: el.p_name.split("_"),
              status: "0",
              p_isfile: el.p_isfile,
            });
          });
          this.videoList = this.list;

          this.playVideo(this.videoList[0], 0);
        } else {
          this.$message.warn("没有视频！");
          this.list = [];
        }
      });
    },
    // 播放第几段视频
    playVideo(item, index) {
      // console.log("item", item);
      this.showName = true;
      this.nowplayname =
        moment(item.p_name[0] * 1000).format("YYYY年MM月DD日 HH时mm分ss秒") +
        "—" +
        moment(item.p_name[1] * 1000).format("YYYY年MM月DD日 HH时mm分ss秒");
      this.showVideo = false;
      let params = {
        w_id: this.record.ws_id,
        ws_id: item.p_id,
        ws_time: "",
        type: "2",
        fileexit: "2",
        d_id: this.queryParam.d_id,
      };
      Playback(params)
        .then((res) => {
          if (
            res === null ||
            res === "视频正在上传" ||
            res === "视频正在下载"
          ) {
            this.showVideo = false;
            if (this.cycleTime < this.cycleMax) {
              this.timer = setTimeout(() => {
                this.playVideo(item);
                this.cycleTime++;
              }, 5000);
            } else {
              this.$message.warn("获取视频超时");
            }
          } else {
            console.log("请求到视频流");
            this.showVideo = true;
            window.clearTimeout(this.timer);
            this.video.play =
              urlConfig.baseUrl +
              `/files/api/worksite/playback?w_id=${params.w_id}&ws_id=${params.ws_id}&ws_time=${params.ws_time}&type=${params.type}&fileexit=1`;
          }
        })
        .then(() => {
          // console.log(index);this.videoList.length
          for (let index1 = 0; index1 < this.videoList.length; index1++) {
            let p_name_date = document.getElementsByClassName("p_name_date");
            // p_name_date[index1].style.color = "#fffff";

            if (index1 != index) {
              p_name_date[index1].style.color = "#000";
              // console.log("black");
            } else {
              p_name_date[index].style.color = "#1890ff";
              // console.log("blue");
            }
            // console.log(p_name_date[index1]);
          }
          // setTimeout(() => {
          //   let p_name_date = document.getElementsByClassName("p_name_date");
          //   p_name_date[index].style.color = "#1890ff";
          // }, 100);
        });
    },
    // 快进/快退
    speed(type) {
      let Media = document.getElementById("video");
      let time = 10; //单位秒，每次增减10秒
      if (type === "back") {
        Media.currentTime !== 0 ? (Media.currentTime -= time) : 1;
      } else if (type === "forward") {
        Media.volume !== Media.duration ? (Media.currentTime += time) : 1;
      }
    },

    aftermouseOver() {
      this.afterplayBackground1 = "#2867CE";
      this.afterplayBackground2 = "#BDD2EF";
    },
    aftermouseLeave() {
      this.afterplayBackground1 = "#333333";
      this.afterplayBackground2 = "#d9d9d9";
    },
    frontmouseOver() {
      this.frontplayBackground1 = "#2867CE";
      this.frontplayBackground2 = "#BDD2EF";
    },
    frontmouseLeave() {
      this.frontplayBackground1 = "#333333";
      this.frontplayBackground2 = "#d9d9d9";
    },
    downmouseOver() {
      this.downplayBackground1 = "#2867CE";
      this.downplayBackground2 = "#BDD2EF";
    },
    downmouseLeave() {
      this.downplayBackground1 = "#333333";
      this.downplayBackground2 = "#d9d9d9";
    },
    //视频下载
    downPlay() {
      axios
        .post(
          this.video.play,
          {
            //Range: bytes=9469952-
            //'data':this.data//请求数据
          },
          {
            responseType: "blob", //服务器返回的数据类型
          }
        )
        .then((res) => {
          //Content-Length: 1067887
          //Content-Range: bytes 12550144-13618030/13618031

          //此处有个坑。这里用content保存文件流，最初是content=res，但下载的test.xls里的内容如下图1，
          //检查了下才发现，后端对文件流做了一层封装，所以将content指向res.data即可
          //另外，流的转储属于浅拷贝，所以此处的content转储仅仅是便于理解，并没有实际作用=_=
          const content = res.data;
          const blob = new Blob([content]); //构造一个blob对象来处理数据
          const fileName = this.nowplayname + ".mp4";

          //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
          //IE10以上支持blob但是依然不支持download
          if ("download" in document.createElement("a")) {
            //支持a标签download的浏览器
            const link = document.createElement("a"); //创建a标签
            link.download = fileName; //a标签添加属性
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click(); //执行下载
            URL.revokeObjectURL(link.href); //释放url
            document.body.removeChild(link); //释放标签
          } else {
            //其他浏览器
            navigator.msSaveBlob(blob, fileName);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 关闭
    close() {
      this.cycleTime = this.cycleMax;
      window.clearTimeout(this.timer);
    },
    // 静音/取消静音按钮
    handelPlay(type) {
      // this.$refs.videoPlayer.play(); // 会触发videoPlay()函数
      let jingyin = document.getElementById("video");
      if (type == "jingyin") {
        jingyin.muted = true;
        this.jingyin = 2;
        console.log("静音");
      } else if (type == "quxiaojingyin") {
        jingyin.muted = false;
        this.jingyin = 1;
        console.log("取消静音");
      }
    },
    // 暂停播放按钮
    bofangPlay(type) {
      let bofang = document.getElementById("video");
      if (type == "bofang") {
        bofang.play();
        this.bofang = 2;
      } else if (type == "zanting") {
        bofang.pause();
        this.bofang = 1;
      }
    },
    // 播放速度
    bofangRate() {
      let bofangRate = document.getElementById("video");
      bofangRate.playbackRate = 2;
      // console.log(bofangRate.networkState);
    },
    // 全屏
    quanping() {
      let quanping = document.getElementById("video");
      quanping.webkitRequestFullScreen();
    },
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    // 改变设备号
    changed_id(e, index) {
      console.log("改变设备号", e);
      this.queryParam.d_id = e;
      this.startMoren();
      this.getdateList();
      console.log(this.ws_bind_d_ids.length);
      for (let index1 = 0; index1 < this.ws_bind_d_ids.length; index1++) {
        console.log("222");
        let BGCblue = document.getElementsByClassName("deviseList_name");
        if (index1 != index) {
          BGCblue[index1].style.background = "#cfe7fa";
          BGCblue[index1].style.color = "#1486e6";
        } else {
          //被点击
          BGCblue[index1].style.color = "#cfe7fa";
          BGCblue[index1].style.background = "#1486e6";
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
// .ant-calendar-cell,
// .ant-calendar-selected-date,
// .ant-calendar-selected-day {
//   color: red !important  ;
// }
.bm-view {
  width: 100%;
  height: 300px;
}
.progress {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.prog-item {
  width: 50%;
  height: 5px;
  line-height: 5px;
  border-left: 1px solid #ccc;
}
.status0 {
  // background: rgba(24, 144, 255, 0.3);
  background: #1890ff;
}
.status1 {
  background: #1890ff;
}
.speed-btn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: space-between;
}
.speed-btn + .speed-btn {
  margin-left: 10px;
}
.speed-btn .icon {
  cursor: pointer;
}
.downPlay {
  // margin-top: 10px;
  margin-right: 5px;
}
.NoVideo {
  width: "100%";
  height: "300px";
  text-align: center;
  line-height: 300px;
  font-size: 20px;
  font-weight: 800;
}
// 页面宽度小于1080时
@media screen and (max-width: 1800px) {
  .calendar_rili {
    position: absolute;
    // margin-left: 38%;
    margin-left: 5%;
    background-color: #fff;
    z-index: 999;
  }
}
//页面宽度大于等于1080px时，背景变红色。
@media screen and (min-width: 1800px) {
  .calendar_rili {
    position: absolute;
    // margin-left: 38%;
    margin-left: 5%;
    background-color: #fff;
    z-index: 999;
  }
}
/deep/.ant-badge-status-error {
  background-color: gray;
  border-radius: 50%;
}
/deep/.ant-badge-status-success {
  background-color: #1890ff;
  border-radius: 50%;
}
.calendar_input {
  position: relative;
  width: 260px;
}
/deep/.a-tooltip {
  outline: none !important;
}
.playBTN {
  // margin-right: 20px;
  margin-top: 10px;
  .a_button {
    margin-right: 5px;
  }
}
.speedBTN {
  margin-left: -40px;
}
// // 播放按钮
video::-webkit-media-controls-play-button {
  display: none !important;
}
// 当前播放时间
// video::-webkit-media-controls-current-time-display {
//   display: none !important;
// }
// 剩余时间
// video::-webkit-media-controls-time-remaining-display {
//   display: none !important;
// }
// 音量按钮
// video::-webkit-media-controls-volume-control-container {
//   display: none !important;
// }
// 全屏
video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}
.haveVideo {
  display: flex;
  width: 100%;
  .haveVideo_left {
    width: 68%;
    padding-right: 5px;
  }
  .haveVideo_right {
    width: 32%;
    height: 300px;
    // background-color: pink;
    .border {
      margin-top: 5px;
      border: 1px rgba(48, 48, 48, 0.5) solid;
      height: 100%;
      overflow: scroll;
      overflow-x: hidden;
    }
    .pointer {
      cursor: pointer;
      padding-left: 5px;
    }
    .pointer :hover {
      color: #1890ff !important;
    }
    .videoListLength {
      background-color: #000000cb;
      color: #fff;
      text-align: center;
    }
  }
  .p_name_date {
    display: flex;
    // .p_name_time {
    //   //  margin-left: 5px;
    //   // margin-left: 1%;
    // }
  }
}
.siteName {
  font-weight: 800;
  margin-bottom: 5px;
}
.deviseList {
  display: flex;
  margin: 10px 0;
  div {
    margin: 0 5px;
    cursor: pointer;
    display: flex;
  }
  .deviseList_name {
    padding: 5px;
    border-radius: 5px;
    color: #1486e6;
    // background-color: #fff;
    background-color: #cfe7fa;
  }
}
</style>
